import { PropsWithoutRef } from 'react'

import Icon from '@ant-design/icons'
import { IconBaseProps } from '@ant-design/icons/lib/components/Icon'

import { NeImageSvg } from './NeImageSvg'

export const NeImageIcon = (props: PropsWithoutRef<IconBaseProps>) => {
  return <Icon component={NeImageSvg} {...props} />
}
